"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorFactory = errorFactory;

/**
 *
 * @param  {String} [name]    An error from `skybase-core/errors/constants`
 * @param  {String} [message] Message describing the error .
 * @param  {Object} [detail]  An object that will be attached as `detail` property.
 * @param  {Object} [code]    An error code.
 * @return {Object}           An Error() instance.
 */
function errorFactory(name, message) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var code = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var error = new Error();

  if (name === undefined) {
    throw Error('errorFactory::argument "name" must be defined');
  }

  if (message === undefined) {
    throw Error('errorFactory::argument "message" must be defined');
  }

  error.name = name;
  error.message = message;
  error.detail = detail;
  error.code = code;
  return error;
}
//# sourceMappingURL=error-factory.js.map